import React from 'react';
import type { ReactElement, PropsWithoutRef } from 'react';

type Props = {
	title: string;
};

export default function Title({ title }: PropsWithoutRef<Props>): ReactElement {
	return <div className="Title text-h3">{title}</div>;
}
